import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class ResetPasswordGuardService implements CanActivate {
  constructor(public router: Router) {}

  canActivate(): boolean {
    // Permettre l'accès à la page de réinitialisation sans authentification
    return true;
  }
} 